import { useSearchParams } from "react-router-dom";
import { startLoader, stopLoader } from "../redux/features/loaderSlice";
import store from "../redux/store";

export const loader = {
    start: () => store.dispatch(startLoader()),
    stop: () => store.dispatch(stopLoader())
}

export const getparamsString = (params) => {
    const [urlParams] = new useSearchParams()
    return urlParams.get(params);
}